import { defineAsyncComponent } from '../compat/vueCompat';
import { requestDialog } from './requestDialog';
import type { StorageProfileDialogRequest } from './storageProfileDialogRequest';

const StorageProfileDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/StorageProfileDialog.vue'));

export function showStorageProfileDialog(req: StorageProfileDialogRequest) {
  requestDialog(req, StorageProfileDialog);
}
